export default {"src":"/_next/static/media/telegram-icon.2d5f184c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};